export default __webpack_public_path__ + "static/media/p4.4ce895ad.JPG";